/* eslint-disable no-restricted-syntax */
import type {
  AccountId,
  CardProTemplateData,
  GetLedgerCreationDataInterface,
  LedgerTypeId,
  WalletId,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { GraphQLClient } from "graphql-request";

import { GetLedgerCreationDataQuery } from "@/api/graphql/ledgers/getCreationTemplate/queries";

export class GetLedgerCreationData implements GetLedgerCreationDataInterface {
  constructor(private graphqlClient: GraphQLClient) {}

  async search(
    accountId: AccountId,
    ledgerTypeId: LedgerTypeId,
    walletId: WalletId,
  ): Promise<CardProTemplateData> {
    const headers: Record<string, string> = {};
    headers["X-ACCOUNT-ID"] = accountId;

    const result = await this.graphqlClient.request(
      GetLedgerCreationDataQuery,
      {
        request: {
          ledgerTypeId: ledgerTypeId,
          walletId: walletId,
        },
      },
      headers,
    );
    const data = result.LedgersMsGetLedgerCreationData;

    if (!data) {
      throw new Error("No data returned from LedgersMsGetLedgerCreationData");
    }

    return {
      category: data.category ?? "",
      isUnavailable: !!data.isUnavailable,
      rawFormData: data.rawFormData ?? "",
    };
  }
}
